{
    "BANNER": {
        "TITLE": " Nationwide Access to Premium Healthcare",
        "DESCRIPTION": "Pay direct for routine care at the time of service, and less than what you would with insurance because of copays, deductibles, and coinsurances. Our packages are perfect as standalone protection, or as supplements to insurance plans.",
        "BTNTEXT": "View Plans"
    },
    "FEATURE": {
        "TITLE": "Featured in"
    },
    "BENEFITS": {
        "MINI_TITLE": "Benefits you get",
        "TITLE": "Take control of your healthcare",
        "BOX1": {
            "TITLE": "Nationwide Availability",
            "DESCRIPTION": "1M+ community of direct-pay providers across the complete continuum of care"
        },
        "BOX2": {
            "TITLE": "Member Focused Care",
            "DESCRIPTION": "Intuitive workflows with complete price transparency, and 24/7 customer support"
        },
        "BOX3": {
            "TITLE": "Freedom from Contracts",
            "DESCRIPTION": "Monthly plans without commitments, and no “pre-authorizations” to get the care you need!"
        }
    },
    "DISCOUNT": {
        "MINI_TITLE": "Benefits you get",
        "TITLE": "Up to 80% discount on your healthcare needs!",
        "SERVICE1": {
            "TITLE": "Virtual Urgent Care",
            "SUBHEAD1": "Unlimited encounters",
            "SUBHEAD2": "24/7 Availability"
        },
        "SERVICE2": {
            "TITLE": "Mental Health Counseling",
            "SUBHEAD1": "Unlimited Use",
            "SUBHEAD2": "Certified Mental Health Experts"
        },
        "SERVICE3": {
            "TITLE": "Medications",
            "SUBHEAD1": "95% top meds at Zero cost",
            "SUBHEAD2": "70k+ Pharmacies"
        },
        "SERVICE4": {
            "TITLE": "Office Visit",
            "SUBHEAD1": "Up to 35%+ discount",
            "SUBHEAD2": "350k+ Doctors"
        },
        "SERVICE5": {
            "TITLE": "Dental",
            "SUBHEAD1": "Over 60% discount",
            "SUBHEAD2": "265K+ Dentists"
        },
        "SERVICE6": {
            "TITLE": "Vision",
            "SUBHEAD1": "Up to 75% discount",
            "SUBHEAD2": "100k+ Eye Clinics"
        },
        "SERVICE7": {
            "TITLE": "Lab Tests",
            "SUBHEAD1": "Up to 60%+ discount",
            "SUBHEAD2": "2100+ Labs"
        },
        "SERVICE8": {
            "TITLE": "Imaging",
            "SUBHEAD1": "Up to 75% discount",
            "SUBHEAD2": "1200+ Imaging Centers"
        },
        "SERVICE9": {
            "TITLE": "Procedures",
            "SUBHEAD1": "Over 50% discount",
            "SUBHEAD2": "5k+ Surgery Centers"
        },
        "SERVICE10": {
            "TITLE": "Hospitalization & ER visits",
            "SUBHEAD1": "Over 60% savings on premiums",
            "SUBHEAD2": "Nationwide & Global Access"
        },
        "SERVICE11": {
            "TITLE": "Preventive Care",
            "SUBHEAD1": "One office visit, Mammogram, etc.",
            "SUBHEAD2": "Nationwide Availability"
        }
    },
    "MEMBERSHIP": {
        "MINI_TITLE": "Affordable Healthcare solution for you!",
        "TITLE": "Healthcare access with membership, no insurance needed",
        "DENTAL_VISION_LABEL": "Add Dental & Vision Benefits",
        "REDUCE_IN_PERSON_LABEL": " Reduce In-person Primary Care to $10 & Urgent Care to $25 ",
        "LABEL": "This plan includes:",
        "NOTE1": "**Comprehensive plan is not available to residents of WA",
        "NOTE2": "**HealthShare is not available in WA",
        "NOTE3": "**75% off for each additional family member",
        "MEMBERNOTES_LABEL": "Notes:",
        "MEMBERNOTES": " After 3 months, get one subsidized visit (50% reimbursement, up to $150). After 6 months, get a second subsidized visit. Can roll over 1 unused visit to the next year. ",
        "BTN_LABEL": "Get Started Now"
    },
    "DISCOUNT50": {
        "TITLE": "HealthShare- Saves you 50% on large medical expenses and everyday care",
        "DESCRIPTION": "HealthSharing helps in managing large healthcare expenses, but still costs 50% less than typical health insurance. Members are part of a community that collects monthly membership fees. When a member has a large medical need like an ER visit, hospitalization, surgery, etc, it is paid by the HeathSharing community.",
        "MINI_TITLE": "Learn more"
    },
    "TESTIMONIAL": {
        "MINI_TITLE": "Testimonials",
        "TITLE": "See how we've helped our members by hearing their stories."
    },
    "HOWITWORKS": {
        "MINI_TITLE": "How it works",
        "TITLE": "As our member, here's how you can start using your benefits :",
        "STEP1": "Pick a plan to receive discounts with unlimited use.",
        "STEP2": "Make sure to complete your profile after payment to activate the plan.",
        "STEP3": "Connect with the medical provider you need.",
        "STEP4": "Pay the discounted direct-pay rate for your services.",
        "STEP5": "Get the care you need and focus on healing, not worrying about bills in the mail."
    },
    "FAQS": {
        "MINI_TITLE": "How it works",
        "TITLE1": "Frequently",
        "TITLE2": "Asked Questions",
        "DESCRIPTION": "Need help? Reach out to our 24/7 customer support at  <a class='phone' href='tel:8449694325'>844-969-4325</a> and get the assistance you need.",
        "LINK": "Visit Faqs Page",
        "FAQ_LIST": [
            {
                "title": "What’s the difference between WoW Plus and WoW Comprehensive?",
                "description": "WoW Plus is designed for day-to-day healthcare like virtual urgent care, primary care, labs, and meds, at low costs. WoW Comprehensive provides protection for hospitalizations, surgeries, ER visits, and big medical expenses."
            },
            {
                "title": "Do I need traditional insurance if I have a WoW membership?",
                "description": "No. WoW Comprehensive is meant as an alternative to traditional health insurance but WoW Plus is available either as a standalone or as a supplement to an insurance plan."
            },
            {
                "title": "Can I visit a doctor in person?",
                "description": "Yes! Both membership offer access to in-person primary and urgent care clinics at low, fixed prices."
            },
            {
                "title": "What kind of medications are covered?",
                "description": "91% of medications are generics; we provide top 4 out of 5 generics at zero cost with home delivery. Rest of the drugs are available for a discount including International sourcing for brand name medications."
            },
            {
                "title": "Can I cancel my membership anytime?",
                "description": "Yes. There’s no long-term commitment. You can cancel your membership at any time with no penalty."
            }
        ]
    }
}